import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { reduxForm } from "redux-form";
import { USERS } from "helpers/viewContent";
import { getDetail_ } from "store/services/commonService";
import {
  DATE_FORMAT,
  DATE_FORMAT_TIME,
  FORMAT_TIME_VALUE,
} from "helpers/common";
import { PRODUCT_IMG } from "utils/constant";

//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";

const Detail = ({ dispatch, match }) => {
  let editkey = match.params.id;
  const [editData, setEditData] = useState({});
  const [universityAttends, setUniversityAttends] = useState({});
  const [tournamentsAttends, setTournamentsAttends] = useState({});
  const [leaguesAttends, setLeaguesAttends] = useState({});
  const [playingSurface, setPlayingSurface] = useState([]);
  async function getData() {
    try {
      let query = {
        url: "user/view",
        id: editkey,
      };
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getDetail_(query));
      setEditData(res?.body);
      setUniversityAttends(
        res?.body?.user_detail?.universities_attend
          ? JSON.parse(res?.body?.user_detail?.universities_attend)
          : []
      );
      setTournamentsAttends(
        res?.body?.user_detail?.tournaments
          ? JSON.parse(res?.body?.user_detail?.tournaments)
          : []
      );
      setLeaguesAttends(
        res?.body?.user_detail?.leagues_play
          ? JSON.parse(res?.body?.user_detail?.leagues_play)
          : []
      );
      setPlayingSurface(
        res?.body ? JSON.parse(res?.body.preferred_playing_surface) : []
      );
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }

  useEffect(() => {
    if (editkey) {
      getData();
    }
  }, []);

  return (
    <>
      <Helmet title={USERS.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-account-multiple menu-icon"></i>
          </span>{" "}
          {USERS.CURRENT_VIEW}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.users}>User</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Detail
            </li>
          </ol>
        </nav>
      </div>

      <div className="row">
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4>
                <b>Personal info </b>
              </h4>
              <div className="row">
                <div className="col-md-6"></div>
                <div className="float-right">
                  <h4>
                    <b>Total Earning : $ 0 </b>
                  </h4>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      First Name
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.name ? editData?.name : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Last Name</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.last_name ? editData?.last_name : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Email</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.email ? editData?.email : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Nationality
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.nationality ? editData?.nationality : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">City</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.city ? editData?.city : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">State</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.state ? editData?.state : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Date of Birth
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.birth_date
                        ? DATE_FORMAT(editData?.birth_date)
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Gender</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.gender
                        ? editData.gender === "1"
                          ? "Male"
                          : editData?.gender === "2"
                            ? "Female"
                            : editData?.gender === "3"
                              ? "Other"
                              : "N/A"
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Phone</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.phone
                        ? `${editData?.country_code} ${editData?.phone}`
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Preferred Playing Surfaces
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {playingSurface?.length > 0 &&
                        playingSurface?.map((surface) => {
                          return <>{surface}, </>;
                        })}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Player Statistics
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.player_statistics
                        ? `${editData?.player_statistics} `
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      PlatForm Joining Type
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.player_statistics
                        ? `${editData?.platform_joining_type === "2"
                          ? "Player"
                          : "Parent/Guardian"
                        } `
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Playing Style
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.player_style
                        ? `${editData?.player_style} `
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      WTN rating
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.wtn_ranking
                        ? `${editData?.wtn_ranking} `
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">UTR raing</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.utr_ranking
                        ? `${editData?.utr_ranking} `
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Player Age
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.age ? `${editData?.age} years` : "0"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">ZipCode</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.zip_code ? editData?.zip_code : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Max Opponent Age Range
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.max_opponent_age
                        ? `${editData?.max_opponent_age} years`
                        : "0"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Min Opponent Age Range
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.min_opponent_age
                        ? `${editData?.min_opponent_age} years`
                        : "0"}
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <h4>
                <b>Physical Attributes : </b>
              </h4>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Height</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.height ? `${editData?.height} inch` : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Weight</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.weight ? `${editData?.weight} kg` : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Status</label>
                    <div className="col-sm-6 col-form-label">
                      <p
                        className={`badge badge-gradient-${editData?.status == 1 ? "success" : "danger"
                          }`}
                      >
                        {editData?.status == 1 ? "Active" : "Inactive"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Location</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.location ? `${editData?.location}` : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Number of Followers
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.number_of_followers
                        ? `${editData?.number_of_followers}`
                        : "0"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Number of Following
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.number_of_following
                        ? `${editData?.number_of_following}`
                        : "0"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Image</label>
                    <div className="col-sm-6 col-form-label">
                      <a
                        href={editData?.image ? `${editData?.image}` : "#"}
                        target="_blank"
                      >
                        <img
                          src={`${editData?.image ? editData?.image : PRODUCT_IMG
                            }`}
                          className="mb-2 rounded img-view"
                          alt="image"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Created At
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.created_at
                        ? DATE_FORMAT_TIME(editData?.created_at)
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <h4>
                <b>Bio : </b>
              </h4>
              <div className="col-md-12">
                <div className="form-group">
                  <div className="col-sm-12 col-form-label">
                    {editData?.bio ? editData?.bio : "N/A"}
                  </div>
                </div>
              </div>
              <hr />
              {editData?.players_parent_info && (
                <>
                  <h4>
                    <b>Parent/Guardian Detail : </b>
                  </h4>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-6 col-form-label">
                          Parent / Guardian First Name
                        </label>
                        <div className="col-sm-6 col-form-label">
                          {editData?.players_parent_info
                            ? editData?.players_parent_info?.parent_name
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-6 col-form-label">
                          Parent / Guardian Last Name
                        </label>
                        <div className="col-sm-6 col-form-label">
                          {editData?.players_parent_info
                            ? editData?.players_parent_info?.parent_last_name
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-6 col-form-label">
                          How many children
                        </label>
                        <div className="col-sm-6 col-form-label">
                          {editData?.players_parent_info
                            ? editData?.players_parent_info?.children_details
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-6 col-form-label">
                          What is your relationship with player
                        </label>
                        <div className="col-sm-6 col-form-label">
                          {editData?.players_parent_info
                            ? editData?.players_parent_info?.relationship
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <hr />
              {editData?.user_detail?.player_classification === "junior" && (
                <>
                  <h4>
                    <b>
                      Playing classification{" "}
                      {editData?.user_detail?.player_classification}
                    </b>
                  </h4>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-6 col-form-label">
                          Academy Name
                        </label>
                        <div className="col-sm-6 col-form-label">
                          {editData?.user_detail
                            ? editData?.user_detail?.academy_name
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-6 col-form-label">
                          High School
                        </label>
                        <div className="col-sm-6 col-form-label">
                          {editData?.user_detail
                            ? editData?.user_detail?.hight_school
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-6 col-form-label">
                          Graduation Year
                        </label>
                        <div className="col-sm-6 col-form-label">
                          {editData?.user_detail
                            ? editData?.user_detail?.graduation_year
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    {universityAttends.length > 0 && (
                      <div className="col-md-5">
                        <label className="col-sm-6 col-form-label">
                          Top 5 Colleges/Universities to attend{" "}
                        </label>
                        <div class="table-responsive">
                          <table className="table table-striped">
                            {/* <thead>
                                                    <tr>
                                                        <th> Name </th>
                                                    </tr>
                                                    </thead> */}
                            <tbody>
                              {universityAttends.length > 0 &&
                                universityAttends.map((item, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{item?.name ? item?.name : "N/A"}</td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
              {editData?.user_detail?.player_classification === "college" && (
                <>
                  <h4>
                    <b>
                      Playing classification{" "}
                      {editData?.user_detail?.player_classification}
                    </b>
                  </h4>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-6 col-form-label">
                          College/University
                        </label>
                        <div className="col-sm-6 col-form-label">
                          {editData?.user_detail
                            ? editData?.user_detail?.college
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-6 col-form-label">
                          Graduation Year
                        </label>
                        <div className="col-sm-6 col-form-label">
                          {editData?.user_detail
                            ? editData?.user_detail?.graduation_year
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-6 col-form-label">Major</label>
                        <div className="col-sm-6 col-form-label">
                          {editData?.user_detail
                            ? editData?.user_detail?.major
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {editData?.user_detail?.player_classification ===
                "professional" && (
                  <>
                    <h4>
                      <b>
                        Playing classification{" "}
                        {editData?.user_detail?.player_classification}
                      </b>
                    </h4>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-6 col-form-label">
                            Training Facility
                          </label>
                          <div className="col-sm-6 col-form-label">
                            {editData?.user_detail
                              ? editData?.user_detail?.training_facility
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              {editData?.user_detail?.player_classification ===
                "adult_competitive" && (
                  <>
                    <h4>
                      <b>
                        Playing classification{" "}
                        {editData?.user_detail?.player_classification}
                      </b>
                    </h4>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-6 col-form-label">
                            What is your profession
                          </label>
                          <div className="col-sm-6 col-form-label">
                            {editData?.user_detail
                              ? editData?.user_detail?.profession
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                      {tournamentsAttends.length > 0 && (
                        <div className="col-md-5">
                          <label className="col-sm-6 col-form-label">
                            What type of tournaments do you play?{" "}
                          </label>
                          <div class="table-responsive">
                            <table className="table table-striped">
                              {/* <thead>
                                                <tr>
                                                    <th> Name </th>
                                                </tr>
                                                </thead> */}
                              <tbody>
                                {tournamentsAttends.length > 0 &&
                                  tournamentsAttends.map((item, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>{item?.name ? item?.name : "N/A"}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              {editData?.user_detail?.player_classification ===
                "adult_social" && (
                  <>
                    <h4>
                      <b>
                        Playing classification{" "}
                        {editData?.user_detail?.player_classification}
                      </b>
                    </h4>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-6 col-form-label">
                            What is your profession
                          </label>
                          <div className="col-sm-6 col-form-label">
                            {editData?.user_detail
                              ? editData?.user_detail?.profession
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-6 col-form-label">
                            What is your NTRP self ranking
                          </label>
                          <div className="col-sm-6 col-form-label">
                            {editData?.user_detail
                              ? editData?.user_detail?.self_ranking
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                    {leaguesAttends.length > 0 && (
                      <div className="row">
                        <div className="col-md-5">
                          <label className="col-sm-6 col-form-label">
                            What tennis leagues do you play?{" "}
                          </label>
                          <div class="table-responsive">
                            <table className="table table-striped">
                              {/* <thead>
                                                <tr>
                                                    <th> Name </th>
                                                </tr>
                                                </thead> */}
                              <tbody>
                                {leaguesAttends.length > 0 &&
                                  leaguesAttends.map((item, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>{item?.name ? item?.name : "N/A"}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              {/* {editData?.user_detail?.player_classification === 'college' && */}
              <>
                <hr />
                {editData?.user_detail && (
                  <>
                    <h4>
                      <b> Match Preferences</b>
                    </h4>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-6 col-form-label">
                            Preferred Playing Surface
                          </label>
                          <div className="col-sm-6 col-form-label">
                            {playingSurface?.length > 0 &&
                              playingSurface?.map((surface) => {
                                return <>{surface}, </>;
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-6 col-form-label">
                            Home Court Surface Type
                          </label>
                          <div className="col-sm-6 col-form-label">
                            {editData?.user_detail?.home_court_surface_type
                              ? editData?.user_detail?.home_court_surface_type
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-6 col-form-label">
                            Play Mode
                          </label>
                          <div className="col-sm-6 col-form-label">
                            {editData?.user_detail?.playing_mode
                              ? editData?.user_detail?.playing_mode
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-6 col-form-label">
                            Preferred Age Range
                          </label>
                          <div className="col-sm-6 col-form-label">
                            {editData?.opponent_age
                              ? `${editData?.opponent_age} years`
                              : "0"}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-6 col-form-label">
                            Preferred Opponent Gender
                          </label>
                          <div className="col-sm-6 col-form-label">
                            {editData?.opponent_gender
                              ? editData.opponent_gender === "1"
                                ? "Male"
                                : editData?.gender === "2"
                                  ? "Female"
                                  : editData?.opponent_gender === "3"
                                    ? "Other"
                                    : "N/A"
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                    {editData?.home_court_addresses?.length > 0 && (
                      <>
                        <h4>
                          <b>Home Court Address </b>
                        </h4>
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th> Addresses </th>
                              </tr>
                            </thead>
                            <tbody>
                              {editData?.home_court_addresses?.length > 0 &&
                                editData?.home_court_addresses?.map(
                                  (day, i) => {
                                    return (
                                      <>
                                        <tr key={i}>
                                          <td>
                                            <h6>{day.home_court_address}</h6>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                  </>
                )}
              </>
              {/* } */}
              {editData?.weeks_preferences?.length > 0 && (
                <>
                  <hr />
                  <h4>
                    <b>Weeks Preferences </b>
                  </h4>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th> Select Day </th>
                          <th> Earliest Start Time </th>
                          <th> Latest Start Time </th>
                        </tr>
                      </thead>
                      <tbody>
                        {editData?.weeks_preferences?.length > 0 &&
                          editData?.weeks_preferences?.map((day, i) => {
                            return (
                              <>
                                <tr key={i}>
                                  <td>
                                    <h5>{day.day}</h5>
                                  </td>
                                  <td>{FORMAT_TIME_VALUE(day.start_date)}</td>
                                  <td>{FORMAT_TIME_VALUE(day.last_date)}</td>
                                </tr>
                              </>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {};
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Detail);
